import type { HTMLAttributes, Ref } from "react";

import { cn } from "../../utils";

export type BadgeVariant =
  | "default"
  | "success"
  | "error"
  | "buy"
  | "sell"
  | "gray";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  ref?: Ref<HTMLSpanElement>;
  variant?: BadgeVariant;
}

export const Badge = ({
  variant = "default",
  className,
  ref,
  ...props
}: BadgeProps) => {
  const isBasicVariant = ["default", "success", "error"].includes(variant);

  return (
    <span
      ref={ref}
      className={cn(
        "ui:text-xs ui:font-medium",
        {
          "ui:rounded-full ui:px-2 ui:py-1 ui:font-grotesk": isBasicVariant,
          "ui:bg-textSecondary/10 ui:text-textPrimary": variant === "default",
          "ui:bg-success/20 ui:text-success": variant === "success",
          "ui:bg-error/20 ui:text-error": variant === "error",
        },
        {
          "ui:relative ui:flex ui:h-5 ui:w-10 ui:items-center ui:justify-center ui:rounded-sm ui:transition-colors ui:before:absolute ui:before:inset-0 ui:before:rounded-sm ui:before:opacity-100 ui:before:transition-opacity ui:before:ease-in":
            !isBasicVariant,
          "ui:font-grotesk ui:text-textPrimary ui:before:bg-textSecondary/10 ui:dark:before:bg-[linear-gradient(176deg,rgba(255,255,255,0.10)_3.48%,rgba(153,153,153,0.10)_97.87%)]":
            variant === "gray",
          "ui:font-sans ui:text-success ui:before:bg-success/10 ui:dark:before:bg-[linear-gradient(180deg,rgba(78,190,150,0.20)_26.18%,rgba(36,88,69,0.20)_100%)]":
            variant === "buy",
          "ui:font-sans ui:text-error ui:before:bg-error/10 ui:dark:before:bg-[linear-gradient(180deg,rgba(255,86,98,0.20)_29.74%,rgba(153,51,59,0.20)_100%)]":
            variant === "sell",
        },
        className,
      )}
      {...props}
    />
  );
};
